module.exports = __webpack_public_path__ + "static/media/serverless-icon.b7f496a8.svg";